<ion-header>
  <ion-toolbar>
    <ion-title>{{canEditTemplates ? 'Manage Templates' : 'Select Template'}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content scrollY="true">
  <ion-list>
    <!-- Create New Template Button -->
    <ion-item *ngIf="canEditTemplates" button (click)="onCreateNewTemplate()" lines="full">
      <ion-icon name="add-circle-outline" slot="start" color="primary"></ion-icon>
      <ion-label color="primary">
        <strong>Create New Template</strong>
      </ion-label>
    </ion-item>

    <ion-item-divider *ngIf="canEditTemplates">
      <ion-label>Existing Templates</ion-label>
    </ion-item-divider>

    <!-- Template List -->
    <ion-item *ngFor="let template of templates" lines="full">
      <ion-label (click)="onSelectTemplate(template.id)" class="ion-text-wrap">
        {{ template.templateTitle }}
      </ion-label>
      
      <ion-button *ngIf="canEditTemplates"
        slot="end" 
        fill="clear" 
        (click)="onEditTemplate(template.id)"
        title="Edit template"
      >
        <ion-icon slot="icon-only" name="pencil-outline"></ion-icon>
      </ion-button>
      
      <ion-button *ngIf="canEditTemplates"
        slot="end" 
        fill="clear" 
        color="danger"
        (click)="onDeleteTemplate(template)"
        title="Delete template"
      >
        <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
      </ion-button>
    </ion-item>

    <!-- Empty State -->
    <ion-item *ngIf="templates.length === 0" lines="none">
      <ion-label class="ion-text-center ion-text-wrap">
        <p *ngIf="canEditTemplates">No templates available. Create one to get started!</p>
        <p *ngIf="!canEditTemplates">No templates available.</p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>